export default "__VITE_ASSET__CalPqGa0__"